import { render, staticRenderFns } from "./ActivitySelect.vue?vue&type=template&id=5972e812"
import script from "./ActivitySelect.vue?vue&type=script&lang=ts"
export * from "./ActivitySelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports